// text and link data for footer main section
import { Route } from '../utils/config';

export const footerLinkData = [
  {
    title: 'Shop',
    links: [
      { label: 'All Recipes', link: Route.ALL_RECIPES, reload: true },
      { label: 'Frozen Meals', link: Route.FROZEN, reload: true },
    ],
  },
  {
    title: 'Learn More',
    links: [
      { label: 'Why Plants', link: Route.WHY_PLANTS, reload: true },
      { label: 'Gifts', link: Route.GIFTS, reload: true },
      { label: 'Recycle', link: Route.RECYCLE, reload: true },
      { label: 'FAQs', link: Route.FAQS, reload: true },
      { label: 'Contact Us', link: Route.CONTACT_US, reload: true },
      { label: 'Learning Center', link: Route.LEARN_MORE, reload: true },
    ],
  },
  {
    title: 'Connect',
    links: [
      { label: 'Refer & Earn', link: Route.REFER },
      { label: 'Partnerships', link: 'mailto:partnerships@purplecarrot.com', reload: true },
      { label: 'Affiliate Program', link: Route.AFFILIATE, reload: true },
      { label: 'Careers', link: Route.CAREERS, reload: true },
    ],
  },
];

// text and link href for subsection of footer
export const footerSubSectionLinkData = [
  ['Terms & Conditions', Route.TERMS],
  ['Privacy Policy', Route.PRIVACY],
  ['California Privacy Policy', Route.CALIFORNIA_PRIVACY],
  ['Do Not Sell My Info', Route.DO_NOT_SELL],
  ['Accessibility Statement', Route.ACCESSIBILITY],
  ['Site Map', Route.SITE_MAP],
];
